import { combineReducers, createSlice } from '@reduxjs/toolkit';
import { normalize, schema } from 'normalizr';
import { CreateTagDto, TagDto } from '../../../common/PricePrgClient';
import { createAsyncAction } from '../../../utils/actionUtils';

const namespaces = {
    tags: 'tags',
    ui: 'ui'
};
const tagEntity = new schema.Entity<TagDto>('tags', undefined, {
    idAttribute: 'tagId'
});

export const getAllTags = createAsyncAction<void, TagDto[]>(namespaces.tags, 'getAll');
export const createTag = createAsyncAction<CreateTagDto, TagDto>(namespaces.tags, 'createTag');
export const updateTag = createAsyncAction<TagDto, TagDto>(namespaces.tags, 'updateTag');
export const deleteTag = createAsyncAction<number, number>(namespaces.tags, 'deleteTag');

const tagsSlice = createSlice({
    name: namespaces.tags,
    initialState: {} as { [key: string]: TagDto },
    reducers: {},
    extraReducers: builder =>
        builder
            .addCase(getAllTags.success, (state, action) => {
                const normalized = normalize(action.payload, [tagEntity]);
                return normalized.entities.tags ?? {};
            })
            .addCase(createTag.success, (state, action) => {
                state[action.payload.tagId] = action.payload;
            })
            .addCase(updateTag.success, (state, action) => {
                state[action.payload.tagId] = action.payload;
            })
            .addCase(deleteTag.success, (state, action) => {
                delete state[action.payload];
            })
});

export default combineReducers({
    tags: tagsSlice.reducer
});
